import { render, staticRenderFns } from "./AddNotesModal.vue?vue&type=template&id=7addd32b&"
import script from "./AddNotesModal.vue?vue&type=script&lang=js&"
export * from "./AddNotesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports